import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import Ecs from './ecs';
import Commonbuy from './commonbuy';

export default (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(params.commodityCode == 'vm')) {
              _context.next = 4;
              break;
            }

            _context.next = 3;
            return Ecs.getOptions.call(this, params);

          case 3:
            return _context.abrupt('return', _context.sent);

          case 4:
            _context.next = 6;
            return Commonbuy.getOptions.call(this, params);

          case 6:
            return _context.abrupt('return', _context.sent);

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  function getOptions(_x) {
    return _ref.apply(this, arguments);
  }

  return getOptions;
})();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/common-cpq-constraint/es/getOptions.js
// module id = 140
// module chunks = 0